// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"014a5b1f","180":"5fbc438b","208":"997214f3","631":"3aef4d3e","774":"9f71bd0e","787":"2f401298","820":"170e3a79","851":"6356846f"}[chunkId] + ".chunk.js";
};